import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Peter Noble
 * id 825AF439-6839-48DA-A6D4-B62BB2710103
 * name home-minus
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-minus.svg
 * tags
 * - Home Automation 
 */
export const HomeMinusIcon = createSvgIcon(<><path d="M22 17V19H14V17H22M12 3L22 12H18C14.69 12 12 14.69 12 18C12 18.7 12.12 19.37 12.34 20H5V12H2L12 3Z" /></>, 'HomeMinusIcon');
export default HomeMinusIcon